// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let  CreateAlertMessage = function (fieldSet)
{
    this.Code = Message.CODE_CREATE_ALERT_MESSAGE
    PFixMessage.call(this, fieldSet)
}

CreateAlertMessage.prototype = Object.create(PFixMessage.prototype)

CreateAlertMessage.prototype.setUserId = function (userId)
{
    this.setFieldValue(FieldsFactory.FIELD_USER_ID, userId)
}

CreateAlertMessage.prototype.setTradableInstrumentId = function (instrumentId)
{
    this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrumentId)
}

CreateAlertMessage.prototype.setRouteId = function (routeId)
{
    this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId)
}

CreateAlertMessage.prototype.setAlertType = function (alertType)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_TYPE, alertType)
}

CreateAlertMessage.prototype.setAlertCondition = function (alertCondition)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_CONDITION, alertCondition)
}

CreateAlertMessage.prototype.setAlertValue = function (alertValue)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_VALUE, alertValue)
}

CreateAlertMessage.prototype.setAlertImportance = function (alertImportance)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_IMPORTANCE, alertImportance)
}

CreateAlertMessage.prototype.setAlertDate = function (alertDate)
{
    this.setFieldValue(FieldsFactory.FIELD_DATE, alertDate)
}

CreateAlertMessage.prototype.setAlertAfterExecute = function (alertAfterExecute)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE, alertAfterExecute)
}

CreateAlertMessage.prototype.setAlertAction = function (alertAction)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_ACTION, alertAction)
}

CreateAlertMessage.prototype.setAlertNotification = function (alertNotification)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_NOTIFICATION, alertNotification)
}

CreateAlertMessage.prototype.setAlertText = function (alertText)
{
    this.setFieldValue(FieldsFactory.FIELD_TEXT, alertText)
}

CreateAlertMessage.prototype.setAlertLeverage = function (alertLeverage)
{
    this.setFieldValue(FieldsFactory.FIELD_LEVERAGE_SHORT, alertLeverage)
}